import styled from "styled-components";
import {LobbyHeaderDefaultBox} from "./lobby-header.default.box";
import {baseColors} from "../../../themes/definitions/mrgreen/base-colors";
import {Color} from "../../../../common/utils/color-util";
import {STICKY} from "../../../themes/css-global-classes";

export const LobbyHeaderMrGreenBox = styled(LobbyHeaderDefaultBox)`
  background-color: ${baseColors.gray033};
  &.${STICKY} {
    background-color: ${Color.fromHex(baseColors.gray033, 0.85).hexa()};
    @supports (backdrop-filter: blur(6px)) {
      background-color: ${Color.fromHex(baseColors.black, 0.5).hexa()};
      backdrop-filter: blur(10px);
    }
  }
`;
